module.exports = __webpack_public_path__ + "assets/media/brian_moseley_face.69884908.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/MoseleyTestimonial/brian_moseley_face.png
// module id = 2598
// module chunks = 0